import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { WarehouseLocation } from '../../models/warehouse-location.model';
import { WarehouseLocationService } from '../../services/warehouse-location.service';
import { WarehouseLocationValidatorService } from '../../validators/warehouse-location-validator.service';

@Component({
    selector: 'app-locations-edit',
    templateUrl: './locations-edit.component.html',
    styleUrls: ['./locations-edit.component.scss'],
    standalone: false
})
export class LocationsEditComponent implements OnInit {

  warehouseLocation: WarehouseLocation = new WarehouseLocation();

  isError: boolean = false;
  isServerError: boolean = false;
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute,
    private warehouseLocationValidator: WarehouseLocationValidatorService,
    private warehouseLocationService: WarehouseLocationService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadWarehouseLocation(+params['id']);
    })
  }

  loadWarehouseLocation(id: number): void {
    this.warehouseLocationService.getWarehouseLocationById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      this.isServerError = true;
      return e;
    }))
    .subscribe((warehouseLocation: WarehouseLocation) => {
      this.warehouseLocation = warehouseLocation;
    })
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;
    this.isSuccess = false;

    if (this.warehouseLocationValidator.isValid(this.warehouseLocation)) {
      this.warehouseLocationService.updateWarehouseLocation(this.warehouseLocation)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        this.isSuccess = true;
      })
    } else {
      this.isError = true;
    }
  }
}
